import React, { useState, useEffect } from 'react';
import './Dashboard.css';
import PatientDetail from './PatientDetail'; // Yeni komponenti import edək

const Dashboard = ({ onLogout, currentUser, onUserUpdate }) => {
  const [activeView, setActiveView] = useState('menu');
  const [appointments, setAppointments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedFilial, setSelectedFilial] = useState('Hamısı');
  const [searchTerm, setSearchTerm] = useState('');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
  // Cədvəllər üçün state-lər
  const [teacherSchedule, setTeacherSchedule] = useState([]);
  const [selectedScheduleBranch, setSelectedScheduleBranch] = useState(null);
  const [scheduleFilterType, setScheduleFilterType] = useState('today'); // 'today', 'tomorrow', 'custom'
  const [customStartDate, setCustomStartDate] = useState('');
  const [singleDate, setSingleDate] = useState('');
  const [customEndDate, setCustomEndDate] = useState('');
  const [scheduleStatusFilter, setScheduleStatusFilter] = useState('all'); // 'all', 'geldi', 'gozleyir', 'gelmedi'
  // currentUser is now passed as a prop, so no need to fetch from localStorage here
  // const currentUser = JSON.parse(localStorage.getItem('user')) || {}; // REMOVE THIS LINE

  const filialList = ['Hamısı', ...new Set(appointments.map(app => app.filial))];

  const [selectedPatient, setSelectedPatient] = useState(null); // Seçilmiş xəstə state'i
  const [selectedAppointment, setSelectedAppointment] = useState(null); // Seçilmiş görüş state'i
  const [initialTestToOpen, setInitialTestToOpen] = useState(null);
  const [initialTestToView, setInitialTestToView] = useState(null);

  // Maliyyə üçün state-lər
  const [selectedFinanceBranch, setSelectedFinanceBranch] = useState(null);
  const [financeData, setFinanceData] = useState(null);
  const [financeLoading, setFinanceLoading] = useState(false);
  const [financeError, setFinanceError] = useState(null);
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);

  // Admin Panel states
  const [adminActiveTab, setAdminActiveTab] = useState('tests'); // 'tests', 'reviews', 'consultations', 'videos', 'qeeg'
  const [adminData, setAdminData] = useState([]);
  const [adminLoading, setAdminLoading] = useState(false);
  const [adminStartDate, setAdminStartDate] = useState('');
  const [adminEndDate, setAdminEndDate] = useState('');
  const [adminDbName, setAdminDbName] = useState('Hamısı');
  const [adminDatabases, setAdminDatabases] = useState([]);
  const [adminObiFilter, setAdminObiFilter] = useState('all');

  const [unregisteredPatients, setUnregisteredPatients] = useState([]);
  const [showNewConsultationModal, setShowNewConsultationModal] = useState(false);
  const [newConsultationForm, setNewConsultationForm] = useState({ ad: '', yas: '', telefon: '', fin: '', konsultasiya_tarixi: '', konsultasiya_saati: '', assigned_teacher: '' });
  const [teachers, setTeachers] = useState([]);
  const [consultationTab, setConsultationTab] = useState('today'); // 'today', 'all'
  const [showTeacherDropdown, setShowTeacherDropdown] = useState(false);
  const [teacherSearch, setTeacherSearch] = useState('');
  const [consultationTeacherFilter, setConsultationTeacherFilter] = useState('Hamısı');

  useEffect(() => {
      if (currentUser?.level === 3) {
          fetch('/api/admin/databases')
            .then(r => r.json())
            .then(data => {
                if(data.success) setAdminDatabases(data.databases);
            });
      }
  }, [currentUser]);

  useEffect(() => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    setAdminStartDate(`${yyyy}-${mm}-01`);
    setAdminEndDate(`${yyyy}-${mm}-${dd}`);
  }, []);

  const fetchAdminData = async () => {
    if (!adminStartDate || !adminEndDate) return;
    setAdminLoading(true);
    try {
        const response = await fetch(`/api/admin/dashboard-data?startDate=${adminStartDate}&endDate=${adminEndDate}&dbName=${adminDbName}&type=${adminActiveTab}`);
        const result = await response.json();
        if (result.success) setAdminData(result.data);
    } catch (e) {
        console.error("Admin data error:", e);
    } finally {
        setAdminLoading(false);
    }
  };

  const refreshUser = async () => {
    if (!currentUser?.username) return currentUser;
    try {
      const res = await fetch(`/api/user/refresh?username=${currentUser.username}`);
      if (res.status === 404 || res.status === 401) {
        onLogout();
        return null;
      }
      if (res.ok) {
        const data = await res.json();
        if (onUserUpdate) onUserUpdate(data.user);
        return data.user;
      }
    } catch (e) {
      console.error("İstifadəçi yenilənməsi xətası:", e);
    }
    return currentUser;
  };

  useEffect(() => {
    refreshUser();
  }, []);

  const handleViewChange = async (view) => {
    await refreshUser();
    setActiveView(view);
    if (view === 's_konsultasiyalar') {
        setConsultationTab('today');
    }
  };

  // 'qebullar' görünüşü aktiv olduqda API-dən məlumatları çək
  useEffect(() => {
    if (activeView === 'qebullar') {
      setLoading(true);
      setError(null);
      fetch(`/api/appointments/today?fin=${currentUser?.fin || ''}&level=${currentUser?.level || 0}`)
        .then(async response => {
          if (!response.ok) {
            // Serverdən gələn xəta mesajını oxumağa çalışırıq
            const errorData = await response.json().catch(() => null);
            const errorMessage = errorData?.message || `Server xətası: ${response.status}`;
            throw new Error(errorMessage);
          }
          return response.json();
        })
        .then(data => {
          setAppointments(data);
        })
        .catch(err => {
          console.error("API Xətası (Qəbullar):", err);
          setError(err.message);
        })
        .finally(() => {
            setLoading(false);
        });
    }
    if (activeView === 'xesteler') {
      setLoading(true);
      setError(null);
      fetch(`/api/appointments/xesteler?fin=${currentUser?.fin || ''}&level=${currentUser?.level || 0}`)
        .then(async response => {
          if (!response.ok) {
            // Serverdən gələn xəta mesajını oxumağa çalışırıq
            const errorData = await response.json().catch(() => null);
            const errorMessage = errorData?.message || `Server xətası: ${response.status}`;
            throw new Error(errorMessage);
          }
          return response.json();
        })
        .then(data => {
          setAppointments(data);
        })
        .catch(err => {
          console.error("API Xətası (Qəbullar):", err);
          setError(err.message);
        })
        .finally(() => {
            setLoading(false);
        });
    }
    if (activeView === 's_konsultasiyalar') {
      setLoading(true);
      setError(null);
      fetch('/api/consultations/list')
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            setUnregisteredPatients(data.data);
          } else {
            throw new Error(data.message);
          }
        })
        .catch(err => {
          console.error("API Xətası:", err);
          setError(err.message);
        })
        .finally(() => setLoading(false));
        
      fetch('/api/teachers')
        .then(res => res.json())
        .then(data => {
          if (data.success) {
              setTeachers(data.data);
              if (currentUser?.level === 3) {
                  const me = data.data.find(t => t.fin === currentUser?.fin);
                  if (me) {
                      setConsultationTeacherFilter(me.ad);
                  }
              }
          }
        })
        .catch(err => console.error("Müəllimlər yüklənmədi:", err));
    }
  }, [activeView]);

  useEffect(() => {
    if (activeView === 'admin_panel' && currentUser?.level === 3) {
        fetchAdminData();
    }
  }, [activeView, adminActiveTab, adminStartDate, adminEndDate, adminDbName]);

  // BLOB/Buffer məlumatlarını təhlükəsiz şəkildə mətnə çevirən köməkçi funksiya
  const formatText = (data) => {
    if (!data) return '';
    // Əgər məlumat bir obyektdirsə (Buffer/BLOB kimi {type, data} açarları varsa)
    if (data && typeof data === 'object') {
      // Node.js-dən gələn Buffer strukturu adətən data.data içində olur
      if (data.data) {
        return new TextDecoder().decode(new Uint8Array(data.data));
      }
      return JSON.stringify(data);
    }
    return String(data);
  };

  // Filtrelenmiş listeyi hesapla (həm filial, həm də ad üzrə axtarış)
  const filteredAppointments = appointments.filter(app => {
    const matchFilial = selectedFilial === 'Hamısı' || app.filial === selectedFilial;
    const patientName = formatText(app.patientName).toLowerCase();
    const matchName = patientName.includes(searchTerm.toLowerCase());
    return matchFilial && matchName;
  });

  // Xəstə detal görünüşünü açan funksiya
  const handlePatientClick = async (appointment) => {
    const updatedUser = await refreshUser();
    if (!updatedUser) return;

    // Konsoldaki isme göre (patientId ve eksik olan dbName)
    const patientId = appointment.patientId ?? appointment.patient_id ?? appointment.id; 
    const dbName = appointment.dbName ?? appointment.db_name ?? appointment.baza; 

    console.log("Düzeltilmiş ID:", patientId, "DB Adı:", dbName);

    if (!dbName) {
        alert("Hata: Veritabanı adı (dbName) alınamadı. API tarafını kontrol edin.");
        return;
    }

    setLoading(true);
    try {
        // URL'i oluştururken dbName'in varlığından emin oluyoruz
        const response = await fetch(`/api/users/${encodeURIComponent(dbName)}/${patientId}`);
          if (!response.ok) {
        const errorData = await response.json().catch(() => null);
        const errorMessage = errorData?.message || `Server xətası: ${response.status}`;
        throw new Error(errorMessage);
      }
      const patientData = await response.json();
      setSelectedPatient(patientData);
      setSelectedAppointment(appointment); // Görüş məlumatını da state-də saxlayırıq
    } catch (err) {
      console.error("API Xətası (Xəstə detalları):", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Admin panelindən testə klikləyəndə detal görünüşünü açan funksiya
  const handleAdminTestClick = async (testResult) => {
    await refreshUser();
    const patientId = testResult.patient_id;
    const dbName = testResult.db_name;

    if (!dbName || !patientId) {
      alert("Xəta: Pasiyent ID və ya Baza adı (dbName) tapılmadı.");
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await fetch(`/api/users/${encodeURIComponent(dbName)}/${patientId}`);
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `Server xətası: ${response.status}`);
      }
      const patientData = await response.json();

      // PatientDetail komponentinin açılması üçün lazımi state-ləri təyin edirik
      setSelectedPatient(patientData);
      // PatientDetail-in açılması üçün `selectedAppointment` tələb olunur, ona görə mock bir obyekt yaradırıq
      setSelectedAppointment({ patientId, dbName, patientName: patientData.ad });
      // PatientDetail-in içində birbaşa testi açmaq üçün bu state-i istifadə edirik
      setInitialTestToView(testResult);

    } catch (err) {
      console.error("Admin panel test açma xətası:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // Xəstə detal görünüşünü bağlayan funksiya
  const handleCloseDetail = () => {
    setSelectedAppointment(null);
    setSelectedPatient(null);
    setInitialTestToOpen(null); // Bunu əlavə edirik ki, modal bağlananda test açma state-i sıfırlansın
    setInitialTestToView(null);
  };

  // Müəllimin cədvəlini gətirən funksiya
  const fetchSchedule = (branch, filterType = 'today', startDate = '', endDate = '') => {
    if (!branch) return; // Əgər filial seçilməyibsə, heç nə etmə

    // setSelectedScheduleBranch(branch); // Bu artıq useEffect tərəfindən idarə olunur
    setLoading(true);
    setError(null);

    let url = `/api/teacher/schedule/${branch.dbName}/${branch.teacherId}`;
    const params = new URLSearchParams();

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1);

    if (filterType === 'today') {
      params.append('startDate', today.toISOString().split('T')[0]);
      params.append('endDate', today.toISOString().split('T')[0]);
    } else if (filterType === 'tomorrow') {
      params.append('startDate', tomorrow.toISOString().split('T')[0]);
      params.append('endDate', tomorrow.toISOString().split('T')[0]);
    } else if (filterType === 'custom' && startDate && endDate) {
      params.append('startDate', startDate);
      params.append('endDate', endDate);
    } else if (filterType === 'single' && startDate) {
      // Tək tarix seçimi üçün startDate-i həm başlanğıc, həm də son tarix kimi göndəririk
      params.append('startDate', startDate);
      params.append('endDate', startDate);
    }

    if (params.toString()) {
      url += `?${params.toString()}`;
    }

    fetch(url)
      .then(res => res.json())
      .then(data => {
        setTeacherSchedule(data);
      })
      .catch(err => {
        console.error("Cədvəl xətası:", err);
        setError("Cədvəl yüklənərkən xəta baş verdi.");
      })
      .finally(() => setLoading(false));
  };

  // selectedScheduleBranch, tarix filtrləri və ya tək tarix dəyişdikdə cədvəli yenidən yüklə
  useEffect(() => {
    if (selectedScheduleBranch) {
      fetchSchedule(selectedScheduleBranch, scheduleFilterType, customStartDate || singleDate, customEndDate);
    }
  }, [selectedScheduleBranch, scheduleFilterType, customStartDate, customEndDate, singleDate]);

  // Maliyyə məlumatlarını çəkmək üçün useEffect
  useEffect(() => {
    const fetchFinanceData = async () => {
      if (!selectedFinanceBranch) return;
      setFinanceLoading(true);
      setFinanceError(null);
      setFinanceData(null);
      try {
        // 1. Cari maaş dövrü ID-sini tap
        const currentRes = await fetch(`/api/finance/current-salary/${selectedFinanceBranch.dbName}/${selectedFinanceBranch.teacherId}`);
        const currentData = await currentRes.json();
        if (!currentRes.ok) throw new Error(currentData.message || "Maaş dövrü tapılmadı.");

        // 2. Maaş detallarını gətir
        const detailsRes = await fetch(`/api/finance/salary-details/${selectedFinanceBranch.dbName}/${currentData.maasId}`);
        const detailsData = await detailsRes.json();
        if (!detailsRes.ok) throw new Error(detailsData.message || "Maaş detalları yüklənmədi.");

        setFinanceData(detailsData);
      } catch (err) {
        setFinanceError(err.message);
      } finally {
        setFinanceLoading(false);
      }
    };

    if (activeView === 'maliyya' && selectedFinanceBranch) {
      fetchFinanceData();
    }
  }, [activeView, selectedFinanceBranch]);

  // Ikonlu Ana Menyu (Mobil və Dashboard başlanğıcı üçün)
  const renderIconMenu = () => (
    <div className="icon-grid-container">
      <div className="icon-card" onClick={() => handleViewChange('qebullar')}>
        <div className="icon-box blue">📅</div>
        <span>Bugünkü Seanslar</span>
      </div>
      <div className="icon-card" onClick={() => handleViewChange('xesteler')}>
        <div className="icon-box green">👥</div>
        <span>Pasiyentlər</span>
      </div>
      <div className="icon-card" onClick={() => handleViewChange('s_konsultasiyalar')}>
        <div className="icon-box" style={{ backgroundColor: '#f39c12' }}>📝</div>
        <span>Sərbəst Konsultasiyalar</span>
      </div>
      <div className="icon-card" onClick={() => handleViewChange('cedveller')}>
        <div className="icon-box purple">📅</div>
        <span>Cədvəllər</span>
      </div>
      <div className="icon-card" onClick={() => handleViewChange('maliyya')}>
        <div className="icon-box gold">💰</div>
        <span>Maliyyə</span>
      </div>
      <div className="icon-card" onClick={() => handleViewChange('ayarlar')}>
        <div className="icon-box gray">⚙️</div>
        <span>Ayarlar</span>
      </div>
      {currentUser?.level === 3 && (
        <div className="icon-card" onClick={() => handleViewChange('admin_panel')}>
          <div className="icon-box" style={{backgroundColor: '#e74c3c'}}>🛡️</div>
          <span>Admin Panel</span>
        </div>
      )}
      <div className="icon-card" onClick={onLogout}>
        <div className="icon-box red">🚪</div>
        <span>Çıxış</span>
      </div>
    </div>
  );

  // Ayarlar Bölməsi
  const renderSettings = () => {
    return (
      <div className="settings-view">
        <h2>Profil və Ayarlar</h2>
        <div className="settings-card">
          <div className="settings-group">
            <label>Ad və Soyad:</label>
            <input type="text" placeholder="Adınızı daxil edin" />
          </div>
          <div className="settings-group">
            <label>Yeni Şifrə:</label>
            <input type="password" placeholder="********" />
          </div>
          <div className="settings-group">
            <label>Şifrəni Təkrarla:</label>
            <input type="password" placeholder="********" />
          </div>
          <button className="save-settings-btn">Məlumatları Yenilə</button>
        </div>
      </div>
    );
  };

  // Cədvəllər Bölməsi
  const renderSchedules = () => {
    const branches = currentUser?.branches || [];
    
    if (!selectedScheduleBranch) {
      return (
        <div className="schedule-selection" style={{ textAlign: 'center', padding: '40px', maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ marginBottom: '20px', color: '#2c3e50' }}>Cədvəli görmək üçün filial seçin</h2>
          {branches.length > 0 ? (
            <div className="branch-grid-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                {branches.map((b, i) => (
                  <div 
                    key={i} 
                    className="branch-card" 
                onClick={async () => { await refreshUser(); setSelectedScheduleBranch(b); }}
                    style={{ 
                      padding: '25px', 
                      border: '1px solid #e0e6ed', 
                      borderRadius: '12px', 
                      backgroundColor: '#fff', 
                      boxShadow: '0 4px 12px rgba(0,0,0,0.05)', 
                      cursor: 'pointer', 
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#1abc9c'}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#e0e6ed'}
                  >
                    <h3 style={{ margin: '0 0 10px 0', color: '#2c3e50', fontSize: '1.2rem' }}>{b.filialName}</h3>
                  </div>
                ))}
            </div>
          ) : (
            <p style={{ color: '#64748b' }}>İşlədiyiniz filial tapılmadı.</p>
          )}
        </div>
      );
    }

    // Statusa görə filtrləmə məntiqi
    const filteredSchedule = teacherSchedule.filter(item => {
      if (scheduleStatusFilter === 'all') return true;
      if (scheduleStatusFilter === 'geldi') return item.tamamlandi == 1;
      if (scheduleStatusFilter === 'gozleyir') return item.tamamlandi == 0 || item.tamamlandi == null;
      if (scheduleStatusFilter === 'gelmedi') return item.tamamlandi != 1 && item.tamamlandi != 0 && item.tamamlandi != null;
      return true;
    });

    return (
      <div className="schedule-view">
        <div className="schedule-header-row">
          <button className="back-btn" onClick={() => setSelectedScheduleBranch(null)}>⬅ Geri</button>
          <h2>{selectedScheduleBranch.filialName} - Fərdi Cədvəlim</h2>
        </div>

        {/* Date Filtering UI */}
        <div className="schedule-filter-controls" style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
          <button 
            className={`filter-button ${scheduleFilterType === 'today' ? 'active' : ''}`} 
            onClick={() => setScheduleFilterType('today')}
            style={{ padding: '8px 15px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: scheduleFilterType === 'today' ? '#1abc9c' : '#f0f0f0', color: scheduleFilterType === 'today' ? '#fff' : '#333', cursor: 'pointer' }}
          >
            Bugün
          </button>
          <button 
            className={`filter-button ${scheduleFilterType === 'tomorrow' ? 'active' : ''}`} 
            onClick={() => setScheduleFilterType('tomorrow')}
            style={{ padding: '8px 15px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: scheduleFilterType === 'tomorrow' ? '#1abc9c' : '#f0f0f0', color: scheduleFilterType === 'tomorrow' ? '#fff' : '#333', cursor: 'pointer' }}
          >
            Sabah
          </button>
          <button 
            className={`filter-button ${scheduleFilterType === 'single' ? 'active' : ''}`} 
            onClick={() => {
              setScheduleFilterType('single');
              const today = new Date().toISOString().split('T')[0];
              setSingleDate(today); // Tək tarix üçün bugünkü tarixi avtomatik doldur
            }}
            style={{ padding: '8px 15px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: scheduleFilterType === 'single' ? '#1abc9c' : '#f0f0f0', color: scheduleFilterType === 'single' ? '#fff' : '#333', cursor: 'pointer' }}
          >
            Tək Tarix
          </button>

          {scheduleFilterType === 'single' && (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input 
                type="date" 
                value={singleDate} 
                onChange={(e) => setSingleDate(e.target.value)} 
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              />
            </div>
          )}

          <button 
            className={`filter-button ${scheduleFilterType === 'custom' ? 'active' : ''}`} 
            onClick={() => {
              setScheduleFilterType('custom');
              const today = new Date();
              const currentYear = today.getFullYear();
              const currentMonth = (today.getMonth() + 1).toString().padStart(2, '0');
              setCustomStartDate(`${currentYear}-${currentMonth}-01`); // Ayın 11-i
              setCustomEndDate(`${currentYear}-${currentMonth}-31`);   // Ayın 31-i
            }}
            style={{ padding: '8px 15px', borderRadius: '5px', border: '1px solid #ccc', backgroundColor: scheduleFilterType === 'custom' ? '#1abc9c' : '#f0f0f0', color: scheduleFilterType === 'custom' ? '#fff' : '#333', cursor: 'pointer' }}
          >
            Tarix Aralığı
          </button>

          {scheduleFilterType === 'custom' && (
            <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
              <input 
                type="date" 
                value={customStartDate} 
                onChange={(e) => setCustomStartDate(e.target.value)} 
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              />
              <span>-</span>
              <input 
                type="date" 
                value={customEndDate} 
                onChange={(e) => setCustomEndDate(e.target.value)} 
                style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
              />
            </div>
          )}
        </div>

        {/* Status Filtering UI */}
        <div className="schedule-status-filters" style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
          <button 
            onClick={() => setScheduleStatusFilter('all')}
            style={{ padding: '6px 12px', borderRadius: '20px', border: '1px solid #ccc', backgroundColor: scheduleStatusFilter === 'all' ? '#34495e' : '#fff', color: scheduleStatusFilter === 'all' ? '#fff' : '#333', cursor: 'pointer', fontSize: '0.9rem' }}
          >
            Hamısı
          </button>
          <button 
            onClick={() => setScheduleStatusFilter('geldi')}
            style={{ padding: '6px 12px', borderRadius: '20px', border: '1px solid #10b981', backgroundColor: scheduleStatusFilter === 'geldi' ? '#10b981' : '#fff', color: scheduleStatusFilter === 'geldi' ? '#fff' : '#10b981', cursor: 'pointer', fontSize: '0.9rem' }}
          >
            ✅ Gəldi
          </button>
          <button 
            onClick={() => setScheduleStatusFilter('gozleyir')}
            style={{ padding: '6px 12px', borderRadius: '20px', border: '1px solid #f59e0b', backgroundColor: scheduleStatusFilter === 'gozleyir' ? '#f59e0b' : '#fff', color: scheduleStatusFilter === 'gozleyir' ? '#fff' : '#f59e0b', cursor: 'pointer', fontSize: '0.9rem' }}
          >
            ⏳ Gözləyir
          </button>
          <button 
            onClick={() => setScheduleStatusFilter('gelmedi')}
            style={{ padding: '6px 12px', borderRadius: '20px', border: '1px solid #ef4444', backgroundColor: scheduleStatusFilter === 'gelmedi' ? '#ef4444' : '#fff', color: scheduleStatusFilter === 'gelmedi' ? '#fff' : '#ef4444', cursor: 'pointer', fontSize: '0.9rem' }}
          >
            ❌ Gəlmədi
          </button>
        </div>

        {loading ? <p>Yüklənir...</p> : (
          <div className="table-responsive">
            <table className="schedule-table">
              <thead>
                <tr>
                  <th>Tarix</th>
                  <th>Saat</th>
                  <th>Xəstə</th>
                  <th>Dərs</th>
                  <th style={{ textAlign: 'center' }}>Status</th>
                </tr>
              </thead>
              <tbody>
                {filteredSchedule.map((item, i) => {
                  let statusIcon = '⏳';
                  let statusTitle = 'Gözləyir';
                  if (item.tamamlandi == 1) {
                    statusIcon = '✅';
                    statusTitle = 'Tamamlanıb';
                  } else if (item.tamamlandi != 0 && item.tamamlandi != null) {
                    statusIcon = '❌';
                    statusTitle = 'Ləğv edilib / Gəlməyib';
                  }
                  return (
                    <tr key={i}>
                      <td>{new Date(item.tarix).toLocaleDateString()}</td>
                      <td>{item.saat}</td>
                      <td>{formatText(item.patientName)}</td>
                      <td>{formatText(item.dersAdi)}</td>
                      <td style={{ textAlign: 'center', fontSize: '1.2rem', cursor: 'help' }} title={statusTitle}>{statusIcon}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  // Maliyyə Bölməsi
  const renderFinance = () => {
    const branches = currentUser?.branches || [];
    
    const getCleanDate = (val) => {
      if (!val) return '';
      try {
        const d = new Date(val);
        if (!isNaN(d.getTime())) {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        }
      } catch (e) {}
      return String(val).substring(0, 10);
    };

    const handleDownloadPDF = async () => {
      setIsGeneratingPDF(true); // Yüklənmə ekranını başlat
      try {
        const html2canvas = (await import('html2canvas')).default;
        const jsPDF = (await import('jspdf')).default;
        
        // React-in overlayi ekrana çıxara bilməsi üçün qısa fasilə
        await new Promise(resolve => setTimeout(resolve, 100));

        const element = document.getElementById('finance-pdf-content');
        if (!element) return;

        // Ölçünü kiçiltmək üçün scale 1.5, formatı isə JPEG edirik (Faylın 120MB olmasının qarşısını alır)
        const canvas = await html2canvas(element, { scale: 1.5, useCORS: true, backgroundColor: '#ffffff' });
        const imgData = canvas.toDataURL('image/jpeg', 0.8);
        
        const pdf = new jsPDF('p', 'mm', 'a4'); // Standart A4 formatı
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        
        const ratio = pdfWidth / canvas.width;
        const scaledImgHeight = canvas.height * ratio;
        
        let heightLeft = scaledImgHeight;
        let position = 0;
        
        // Birinci səhifə
        pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, scaledImgHeight);
        heightLeft -= pdfHeight;
        
        // Əgər cədvəl uzundursa, yeni səhifələr (A4) əlavə edib kəsərək yerləşdiririk
        while (heightLeft > 0) {
          position -= pdfHeight;
          pdf.addPage();
          pdf.addImage(imgData, 'JPEG', 0, position, pdfWidth, scaledImgHeight);
          heightLeft -= pdfHeight;
        }
        
        pdf.save(`${selectedFinanceBranch?.filialName || 'Hesabat'}_Maliyye.pdf`);
      } catch (error) {
        console.error("PDF xətası:", error);
        alert("PDF yaradılması üçün əlavə paketlər lazımdır. Zəhmət olmasa terminalda bu əmri işlədin:\nnpm install jspdf html2canvas");
      } finally {
        setIsGeneratingPDF(false); // Yüklənmə ekranını bağla
      }
    };

    if (!selectedFinanceBranch) {
      return (
        <div className="schedule-selection" style={{ textAlign: 'center', padding: '40px', maxWidth: '900px', margin: '0 auto' }}>
          <h2 style={{ marginBottom: '20px', color: '#2c3e50' }}>Maliyyə hesabatını görmək üçün filial seçin</h2>
          {branches.length > 0 ? (
            <div className="branch-grid-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px' }}>
                {branches.map((b, i) => (
                  <div 
                    key={i} 
                    className="branch-card" 
                onClick={async () => { await refreshUser(); setSelectedFinanceBranch(b); }}
                    style={{ 
                      padding: '25px', 
                      border: '1px solid #e0e6ed', 
                      borderRadius: '12px', 
                      backgroundColor: '#fff', 
                      boxShadow: '0 4px 12px rgba(0,0,0,0.05)', 
                      cursor: 'pointer', 
                      transition: 'all 0.3s ease',
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center'
                    }}
                    onMouseOver={(e) => e.currentTarget.style.borderColor = '#1abc9c'}
                    onMouseOut={(e) => e.currentTarget.style.borderColor = '#e0e6ed'}
                  >
                    <h3 style={{ margin: '0 0 10px 0', color: '#2c3e50', fontSize: '1.2rem' }}>{b.filialName}</h3>
                  </div>
                ))}
            </div>
          ) : (
            <p style={{ color: '#64748b' }}>İşlədiyiniz filial tapılmadı.</p>
          )}
        </div>
      );
    }

    return (
      <div className="finance-view">
        {/* PDF Hazırlanarkən göstəriləcək Yüklənmə Ekranı */}
        {isGeneratingPDF && (
          <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', zIndex: 9999, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', backdropFilter: 'blur(3px)' }}>
            <div style={{ border: '4px solid #f3f3f3', borderTop: '4px solid #1abc9c', borderRadius: '50%', width: '50px', height: '50px', animation: 'spin 1s linear infinite' }}></div>
            <p style={{ marginTop: '15px', fontWeight: 'bold', color: '#2c3e50', fontSize: '1.2rem' }}>PDF sənədi hazırlanır, zəhmət olmasa gözləyin...</p>
          </div>
        )}

        <div className="schedule-header-row" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
          <button className="back-btn" onClick={() => setSelectedFinanceBranch(null)}>⬅ Geri</button>
          <h2>{selectedFinanceBranch.filialName} - Maliyyə hesabatı</h2>
        </div>

        {financeLoading ? <p>Yüklənir...</p> : financeError ? <p style={{ color: '#e74c3c', fontWeight: 'bold' }}>Xəta: {financeError}</p> : financeData && financeData.success && (
          <div id="finance-pdf-content" className="finance-content" style={{ display: 'flex', flexDirection: 'column', gap: '30px', backgroundColor: '#fff', padding: '20px', borderRadius: '12px' }}>
            
            {/* Yekun Panel */}
            <div className="finance-summary-card" style={{ backgroundColor: '#fff', padding: '25px', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 4px 10px rgba(0,0,0,0.03)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px', marginBottom: '15px', flexWrap: 'wrap', gap: '15px' }}>
                    <h3 style={{ margin: 0, color: '#2c3e50', fontSize: '1.4rem' }}>Yekun Məbləğ: <span style={{ color: '#10b981' }}>{financeData.summary.yekun_mebleg} AZN</span></h3>
                    <div style={{ display: 'flex', gap: '10px' }} data-html2canvas-ignore="true">
                        <button className="action-button" style={{ backgroundColor: '#e74c3c', margin: 0 }} onClick={handleDownloadPDF}>PDF YÜKLƏ</button>
                        <button className="action-button" style={{ backgroundColor: '#3b82f6', margin: 0 }} onClick={() => window.print()}>ÇAP ET</button>
                    </div>
                </div>
                
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
                    <div style={{ padding: '10px', backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block' }}>Maaş Vaxtı</span>
                        <strong style={{ color: '#334155' }}>{getCleanDate(financeData.summary.tarixb)} / {getCleanDate(financeData.summary.tarixs)}</strong>
                    </div>
                    <div style={{ padding: '10px', backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block' }}>Toplam Dərs</span>
                        <strong style={{ color: '#334155' }}>{financeData.summary.cemders}</strong>
                    </div>
                    <div style={{ padding: '10px', backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block' }}>Toplam Dərs Saatı</span>
                        <strong style={{ color: '#334155' }}>{financeData.summary.cemsaat}</strong>
                    </div>
                    <div style={{ padding: '10px', backgroundColor: '#f8fafc', borderRadius: '8px' }}>
                        <span style={{ fontSize: '0.85rem', color: '#64748b', display: 'block' }}>Toplam Dərs Məbləği</span>
                        <strong style={{ color: '#334155' }}>{financeData.summary.cemqiymet} AZN</strong>
                    </div>
                    <div style={{ padding: '10px', backgroundColor: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0' }}>
                        <span style={{ fontSize: '0.85rem', color: '#166534', display: 'block' }}>Maaş {financeData.summary.maas_faizi}</span>
                        <strong style={{ color: '#166534', fontSize: '1.1rem' }}>{financeData.summary.hesablanmis_maas} AZN</strong>
                    </div>
                    <div style={{ padding: '10px', backgroundColor: '#fef2f2', borderRadius: '8px', border: '1px solid #fecaca' }}>
                        <span style={{ fontSize: '0.85rem', color: '#991b1b', display: 'block' }}>Avans (Çıxılır)</span>
                        <strong style={{ color: '#991b1b', fontSize: '1.1rem' }}>{financeData.summary.avans} AZN</strong>
                    </div>
                </div>
            </div>

            {/* Dərslər Cədvəli */}
            <div className="finance-lessons table-responsive" style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#2c3e50' }}>Dərslərin Siyahısı</h3>
                <table className="schedule-table">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>Tarix-Saat</th>
                            <th>Pasiyent</th>
                            <th>Dərs</th>
                            <th>Müddət / Qiymət</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(() => {
                            let lastDate = null;
                            let dailyTotal = 0;
                            const rows = [];
                            
                            financeData.dersler.forEach((ders, index) => {
                                const tarixStr = getCleanDate(ders.tarix);
                                
                                let timePart = '';
                                if (ders.tarix_saat && ders.tarix_saat.includes(' - ')) {
                                    const parts = ders.tarix_saat.split(' - ');
                                    timePart = parts[parts.length - 1];
                                }
                                const displayDateTime = (timePart && timePart !== 'null' && timePart.trim() !== '') 
                                    ? `${tarixStr} - ${timePart}` 
                                    : tarixStr;
                                
                                if (tarixStr !== lastDate) {
                                    if (lastDate !== null) {
                                        rows.push(
                                            <tr key={`sum-${lastDate}`} style={{ backgroundColor: '#f1f5f9', fontWeight: 'bold' }}>
                                                <td colSpan="4" style={{ textAlign: 'right', color: '#475569' }}>Günlük Toplam:</td>
                                                <td colSpan="1" style={{ color: '#10b981' }}>{dailyTotal.toFixed(2)} m</td>
                                            </tr>
                                        );
                                    }
                                    rows.push(
                                        <tr key={`date-${tarixStr}`} style={{ backgroundColor: '#e2e8f0', fontWeight: 'bold' }}>
                                            <td colSpan="5" style={{ textAlign: 'center', color: '#334155' }}>Tarix: {tarixStr}</td>
                                        </tr>
                                    );
                                    lastDate = tarixStr;
                                    dailyTotal = 0;
                                }
                                
                                dailyTotal += parseFloat(ders.qiymet);
                                
                                rows.push(
                                    <tr key={`ders-${index}`}>
                                        <td>{ders.n}</td>
                                        <td>{displayDateTime}</td>
                                        <td>{ders.pasiyent}</td>
                                        <td>{ders.ders}</td>
                                        <td>{ders.muddet_yazi}</td>
                                    </tr>
                                );
                                
                                if (index === financeData.dersler.length - 1) {
                                    rows.push(
                                        <tr key={`sum-last`} style={{ backgroundColor: '#f1f5f9', fontWeight: 'bold' }}>
                                            <td colSpan="4" style={{ textAlign: 'right', color: '#475569' }}>Günlük Toplam:</td>
                                            <td colSpan="1" style={{ color: '#10b981' }}>{dailyTotal.toFixed(2)} m</td>
                                        </tr>
                                    );
                                }
                            });
                            
                            return rows.length > 0 ? rows : <tr><td colSpan="5" style={{ textAlign: 'center' }}>Dərs tapılmadı</td></tr>;
                        })()}
                    </tbody>
                </table>
            </div>

            {/* Xərclər Cədvəli */}
            <div className="finance-expenses table-responsive" style={{ backgroundColor: '#fff', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                <h3 style={{ margin: '0 0 15px 0', color: '#2c3e50' }}>Xərclər (Avans)</h3>
                <table className="schedule-table">
                    <thead>
                        <tr>
                            <th>N</th>
                            <th>Tarix</th>
                            <th>Səbəb</th>
                            <th>Məbləğ</th>
                        </tr>
                    </thead>
                    <tbody>
                        {financeData.xercler && financeData.xercler.length > 0 ? financeData.xercler.map((xerc, index) => (
                            <tr key={index}>
                                <td>{xerc.n}</td>
                                <td>{getCleanDate(xerc.tarix)}</td>
                                <td>{xerc.sebeb}</td>
                                <td style={{ color: '#ef4444', fontWeight: 'bold' }}>- {xerc.mebleg} AZN</td>
                            </tr>
                        )) : <tr><td colSpan="4" style={{ textAlign: 'center', color: '#94a3b8' }}>Heç bir avans və ya xərc qeydi yoxdur.</td></tr>}
                    </tbody>
                </table>
            </div>

          </div>
        )}
      </div>
    );
  };

  const renderAdminPanel = () => {
      if (currentUser?.level !== 3) return <p>İcazə yoxdur.</p>;

      const getTestResultValue = (item) => {
        const isAGTE = item.test_name?.includes('AGTE');
        if (isAGTE) {
            try {
                const details = typeof item.details === 'string' ? JSON.parse(item.details) : (item.details || {});
                return `${details.generalAge || '-'} ay`;
            } catch (e) { return '-'; }
        }
        return item.index_score != null ? item.index_score : '-';
      };

      const dataToRender = adminData.filter(item => {
        if (adminActiveTab !== 'tests' || adminObiFilter === 'all') {
            return true;
        }
        // OBI filter only applies to GOBDÖ tests which have an index_score
        if (!item.test_name || item.test_name.includes('AGTE') || item.index_score == null) {
            return false;
        }
        const obi = item.index_score;

        switch (adminObiFilter) {
            case '<70': return obi < 70;
            case '70-79': return obi >= 70 && obi < 80;
            case '80-89': return obi >= 80 && obi < 90;
            case '90-99': return obi >= 90 && obi < 100;
            case '100+': return obi >= 100;
            default: return true;
        }
    });

      return (
          <div className="admin-panel-view">
              <h2>Admin Panel - Ümumi Hesabatlar</h2>
              
              <div className="admin-filters" style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginBottom: '20px', alignItems: 'flex-end', backgroundColor: '#f8fafc', padding: '15px', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                  <div>
                      <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 'bold', color: '#64748b'}}>Başlanğıc Tarixi:</label>
                      <input type="date" value={adminStartDate} onChange={e => setAdminStartDate(e.target.value)} style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc'}} />
                  </div>
                  <div>
                      <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 'bold', color: '#64748b'}}>Bitiş Tarixi:</label>
                      <input type="date" value={adminEndDate} onChange={e => setAdminEndDate(e.target.value)} style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc'}} />
                  </div>
                  <div>
                      <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 'bold', color: '#64748b'}}>Baza:</label>
                      <select value={adminDbName} onChange={e => setAdminDbName(e.target.value)} style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc', minWidth: '150px'}}>
                          <option value="Hamısı">Hamısı</option>
                          {adminDatabases.map(b => (
                              <option key={b.ad} value={b.ad}>{b.filial || b.ad} ({b.ad})</option>
                          ))}
                      </select>
                  </div>
                  <div>
                      <label style={{display: 'block', fontSize: '0.85rem', fontWeight: 'bold', color: '#64748b'}}>OBİ Aralığı:</label>
                        <select value={adminObiFilter} onChange={e => setAdminObiFilter(e.target.value)} style={{padding: '8px', borderRadius: '5px', border: '1px solid #ccc', minWidth: '150px'}}>
                            <option value="all">Hamısı</option>
                            <option value="<70">&lt; 70</option>
                            <option value="70-79">70 - 79</option>
                            <option value="80-90">80 - 90</option>
                            <option value="90-100">90 - 100</option>
                            <option value="100+">100+</option>
                            <option value="<70">&lt; 70 (Müşahidə olunmur)</option>
                            <option value="70-79">70 - 79 (Ehtimal var)</option>
                            <option value="80-89">80 - 89 (Yüngül dərəcədə)</option>
                            <option value="90-99">90 - 99 (Orta dərəcədə)</option>
                            <option value="100+">100+ (Yüksək)</option>
                        </select>
                    </div>
              </div>

              <div className="admin-tabs" style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', overflowX: 'auto' }}>
                  {['tests', 'reviews', 'consultations', 'videos', 'qeeg'].map(tab => {
                      const labels = { tests: 'Testlər', reviews: 'Rəylər', consultations: 'Dəyərləndirmələr', videos: 'Videolar', qeeg: 'QEEG Müayinələri' };
                      return (
                          <button 
                              key={tab} 
                              onClick={() => setAdminActiveTab(tab)}
                              style={{ 
                                  padding: '8px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                                  backgroundColor: adminActiveTab === tab ? '#1e293b' : '#e2e8f0',
                                  color: adminActiveTab === tab ? '#fff' : '#475569', fontWeight: 'bold'
                              }}
                          >
                              {labels[tab]}
                          </button>
                      );
                  })}
              </div>

              {adminLoading ? <p>Yüklənir...</p> : (
                  <div className="table-responsive">
                      <table className="schedule-table">
                          <thead>
                              <tr>
                                  <th>Tarix</th>
                                  <th>Baza</th>
                                  <th>Pasiyent Adı (ID)</th>
                                  {adminActiveTab === 'reviews' && <th>Müəllim</th>}
                                  {adminActiveTab === 'tests' && <th>Test Adı</th>}
                                  {adminActiveTab === 'tests' && <th>Nəticə</th>}
                                  {adminActiveTab === 'reviews' && <th>Rəy Mətni</th>}
                                  {adminActiveTab === 'consultations' && <th>Filial / Müraciət Edən</th>}
                                  {adminActiveTab === 'qeeg' && <th>Analiz Nəticəsi</th>}
                                  {adminActiveTab === 'videos' && <th>Status / Link</th>}
                              </tr>
                          </thead>
                          <tbody>
                              {dataToRender.length > 0 ? dataToRender.map((item, idx) => (
                                  <tr 
                                    key={idx} 
                                    onClick={() => adminActiveTab === 'tests' && handleAdminTestClick(item)}
                                    style={{ cursor: adminActiveTab === 'tests' ? 'pointer' : 'default' }}
                                  >
                                      <td style={{whiteSpace: 'nowrap'}}>{item.created_at ? new Date(item.created_at).toLocaleString('az-AZ') : '-'}</td>
                                      <td>{item.db_name || item.baza}</td>
                                      <td style={{fontWeight: 'bold'}}>{item.patient_name} ({item.patient_id || item.user_id})</td>
                                      {adminActiveTab === 'reviews' && <td>{item.teacher_name}</td>}
                                      {adminActiveTab === 'tests' && <td>{item.test_name}</td>}
                                      {adminActiveTab === 'tests' && <td>{getTestResultValue(item)}</td>}
                                      {adminActiveTab === 'reviews' && <td>{item.review_text?.substring(0, 100)}...</td>}
                                      {adminActiveTab === 'consultations' && <td>{item.filial} / {item.applicant_type}</td>}
                                      {adminActiveTab === 'qeeg' && <td>{item.analysis_result?.substring(0, 100)}...</td>}
                                      {adminActiveTab === 'videos' && (
                                          <td>{item.status} {item.link && item.link !== 'pending' && <a href={item.link} target="_blank" rel="noreferrer" style={{display: 'inline-block', marginLeft: '10px', color: '#3b82f6', fontWeight: 'bold'}}>İzlə</a>}</td>
                                      )}
                                  </tr>
                              )) : ( <tr><td colSpan="10" style={{textAlign: 'center', padding: '20px', color: '#94a3b8'}}>Bu aralıqda məlumat tapılmadı.</td></tr> )}
                          </tbody>
                      </table>
                  </div>
              )}
          </div>
      );
  };

    const handleCreateConsultation = async (e) => {
    e.preventDefault();
    if (!newConsultationForm.ad || !newConsultationForm.fin) {
        alert("Ad, Soyad və FİN mütləqdir!");
        return;
    }
    const assignedTeacher = teachers.find(t => t.ad === newConsultationForm.assigned_teacher);
    try {
        const res = await fetch('/api/consultations/create-patient', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ...newConsultationForm,
                teacherFin: currentUser?.fin,
                assignedTeacherFin: assignedTeacher ? assignedTeacher.fin : null
            })
        });
        const data = await res.json();
        if (data.success) {
            const message = data.isExisting
                ? `Mövcud pasiyent (${data.ad}) üçün yeni konsultasiya yaradıldı.`
                : "Yeni pasiyent uğurla yaradıldı!";
            alert(message);
            setShowNewConsultationModal(false);
            setNewConsultationForm({ ad: '', yas: '', telefon: '', fin: '', konsultasiya_tarixi: '', konsultasiya_saati: '', assigned_teacher: '' });
            handleViewChange('s_konsultasiyalar'); // Siyahını yenilə
        } else {
            alert("Xəta: " + data.message);
        }
    } catch (err) {
        alert("Server xətası: " + err.message);
    }
  };

  const handleUnregisteredClick = (patient) => {
      const appointmentMock = {
          patientId: patient.id,
          dbName: 'unregistered',
          patientName: patient.ad,
          filial: 'Sərbəst Qeydiyyat',
          dersAdi: patient.assigned_teacher ? `Konsultasiya (${patient.assigned_teacher})` : 'Konsultasiya',
          saat: patient.konsultasiya_saati || new Date(patient.created_at).toLocaleTimeString('az-AZ', { hour: '2-digit', minute: '2-digit' })
      };
      handlePatientClick(appointmentMock);
  };


  const renderView = () => {
    switch (activeView) {
      case 'menu':
        return renderIconMenu();
      case 'cedveller':
        return renderSchedules();
      case 'maliyya':
        return renderFinance();
      case 'ayarlar':
        return renderSettings();
      case 'admin_panel':
        return renderAdminPanel();
      case 'qebullar':
        if (loading) {
          return <p>Yüklənir...</p>;
        }
        if (error) {
          return <p>Xəta: {error}</p>;
        }
        return (
          <>
            <h2>Bugünkü Qəbullar</h2>
            {appointments.length > 0 ? (
              <ul className="appointment-list">
               
{appointments.map((appointment, index) => (
  // Key olarak sadece patientId kullanmayın, çünkü aynı hasta aynı gün iki kez randevu almış olabilir.
  // appointment.id (cedvel tablosundaki benzersiz ID) kullanmak daha sağlıklıdır.
  <li key={index} className="appointment-item" onClick={() => handlePatientClick(appointment)}>
    <div className="appointment-details">
      {/* İsimleri ve ID'yi tutarlı kullanın */}
      <strong>{formatText(appointment.patientName)} - {appointment.patient_id}</strong>
      
      <p>
        <span>{formatText(appointment.filial)}</span> | 
        <span> {formatText(appointment.dersAdi)}</span> | 
        <span> Saat: {appointment.saat}</span>
      </p>
    </div>
  </li>
))}
              </ul>
            ) : (
              <p>Bu gün üçün planlaşdırılmış qəbul yoxdur.</p>
            )}
          </>
        );
      case 'xesteler':
        return (
        <>
            <h2>Xəstələr ({selectedFilial})</h2>
            
            {loading ? <p>Yüklənir...</p> : (
              <ul className="appointment-list">
                {filteredAppointments.length > 0 ? (
                  filteredAppointments.map((appointment, index) => (
                    <li key={index} className="appointment-item" onClick={() => handlePatientClick(appointment)}>
                      <div className="appointment-details">
                        <strong>{formatText(appointment.patientName)}</strong>
                        <p>
                          <span>{formatText(appointment.filial)}</span>
                        </p>
                      </div>
                    </li>
                  ))
                ) : (
                  <p>Bu filialda xəstə tapılmadı.</p>
                )}
              </ul>
            )}
          </>
        );
      case 's_konsultasiyalar':
        const formatDateStr = (dateVal) => {
            if (!dateVal) return null;
            try { 
                const d = new Date(dateVal);
                if (isNaN(d.getTime())) return null;
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            } catch(e) { return null; }
        };
        const dToday = new Date();
        const todayStr = `${dToday.getFullYear()}-${String(dToday.getMonth() + 1).padStart(2, '0')}-${String(dToday.getDate()).padStart(2, '0')}`;
        
        const visibleUnregisteredPatients = unregisteredPatients.filter(p => {
            if (currentUser?.level === 3) {
                if (consultationTeacherFilter === 'Hamısı') return true;
                return p.assigned_teacher === consultationTeacherFilter;
            } else {
                return p.assigned_teacher === currentUser?.ad;
            }
        });

        const todaysConsultations = visibleUnregisteredPatients.filter(p => formatDateStr(p.konsultasiya_tarixi) === todayStr);
        todaysConsultations.sort((a,b) => (a.konsultasiya_saati || '').localeCompare(b.konsultasiya_saati || ''));

        return (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', flexWrap: 'wrap', gap: '15px' }}>
                <h2 style={{ margin: 0 }}>Sərbəst Konsultasiyalar</h2>
                <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                    {currentUser?.level === 3 && (
                        <select 
                            value={consultationTeacherFilter}
                            onChange={(e) => setConsultationTeacherFilter(e.target.value)}
                            style={{ padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', outline: 'none', backgroundColor: '#fff', minWidth: '200px' }}
                        >
                            <option value="Hamısı">Bütün Mütəxəssislər</option>
                            {teachers.map(t => (
                                <option key={t.id} value={t.ad}>{t.ad}</option>
                            ))}
                        </select>
                    )}
                    <button className="action-button" style={{ margin: 0 }} onClick={() => setShowNewConsultationModal(true)}>+ Yeni Pasiyent</button>
                </div>
            </div>

            {showNewConsultationModal && (
                <div className="patient-detail-modal-overlay" onClick={() => setShowNewConsultationModal(false)} style={{ zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="patient-detail-modal-content" onClick={e => e.stopPropagation()} style={{ width: '400px', maxWidth: '90%', padding: '25px', height: 'auto', borderRadius: '12px' }}>
                        <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#2c3e50' }}>Yeni Pasiyent Qeydiyyatı</h3>
                        <form onSubmit={handleCreateConsultation} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Ad və Soyad *</label>
                                <input type="text" required value={newConsultationForm.ad} onChange={e => setNewConsultationForm({...newConsultationForm, ad: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>FİN *</label>
                                <input type="text" required value={newConsultationForm.fin} onChange={e => setNewConsultationForm({...newConsultationForm, fin: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Doğum Tarixi</label>
                                <input type="date" value={newConsultationForm.yas} onChange={e => setNewConsultationForm({...newConsultationForm, yas: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Telefon</label>
                                <input type="text" placeholder="+994..." value={newConsultationForm.telefon} onChange={e => setNewConsultationForm({...newConsultationForm, telefon: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Konsultasiya Tarixi</label>
                                <input type="date" value={newConsultationForm.konsultasiya_tarixi} onChange={e => setNewConsultationForm({...newConsultationForm, konsultasiya_tarixi: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Konsultasiya Saatı</label>
                                <input type="time" value={newConsultationForm.konsultasiya_saati} onChange={e => setNewConsultationForm({...newConsultationForm, konsultasiya_saati: e.target.value})} style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box' }} />
                            </div>
                            <div>
                                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', fontSize: '0.9rem' }}>Mütəxəssis (Kim edəcək)</label>
                                <div 
                                    onClick={() => setShowTeacherDropdown(true)}
                                    style={{ width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #ccc', boxSizing: 'border-box', backgroundColor: '#fff', cursor: 'pointer', minHeight: '38px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                >
                                    <span>{newConsultationForm.assigned_teacher || "Mütəxəssis seçin..."}</span>
                                    <span style={{ fontSize: '0.8rem', color: '#999' }}>▼</span>
                                </div>
                                
                                {showTeacherDropdown && (
                                    <div className="teacher-modal-overlay" onClick={() => setShowTeacherDropdown(false)} style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <div className="teacher-modal-content" onClick={e => e.stopPropagation()} style={{ backgroundColor: '#fff', padding: '30px', borderRadius: '12px', width: '500px', maxWidth: '90%', maxHeight: '80vh', display: 'flex', flexDirection: 'column', boxShadow: '0 10px 25px rgba(0,0,0,0.3)' }}>
                                            <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#2c3e50', textAlign: 'center' }}>Mütəxəssis Seçin</h3>
                                            <input 
                                                type="text" 
                                                placeholder="Ad ilə axtar..." 
                                                value={teacherSearch}
                                                onChange={e => setTeacherSearch(e.target.value)}
                                                style={{ width: '100%', padding: '12px', border: '1px solid #ccc', borderRadius: '6px', boxSizing: 'border-box', outline: 'none', marginBottom: '15px', fontSize: '1rem' }}
                                            />
                                            <ul style={{ listStyle: 'none', margin: 0, padding: 0, flexGrow: 1, overflowY: 'auto', borderTop: '1px solid #eee', borderBottom: '1px solid #eee' }}>
                                                <li 
                                                    onClick={() => { setNewConsultationForm({...newConsultationForm, assigned_teacher: ''}); setShowTeacherDropdown(false); setTeacherSearch(''); }}
                                                    style={{ padding: '15px', cursor: 'pointer', borderBottom: '1px solid #eee', color: '#e74c3c', fontSize: '1rem', fontWeight: 'bold' }}
                                                    onMouseOver={e => e.target.style.backgroundColor = '#f1f5f9'}
                                                    onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
                                                >
                                                    <em>Seçimi sıfırla</em>
                                                </li>
                                                {teachers.filter(t => t.ad.toLowerCase().includes(teacherSearch.toLowerCase())).map(t => (
                                                    <li 
                                                        key={t.id}
                                                        onClick={() => { setNewConsultationForm({...newConsultationForm, assigned_teacher: t.ad}); setShowTeacherDropdown(false); setTeacherSearch(''); }}
                                                        style={{ padding: '15px', cursor: 'pointer', borderBottom: '1px solid #eee', fontSize: '1rem', transition: 'background-color 0.2s' }}
                                                        onMouseOver={e => e.target.style.backgroundColor = '#f1f5f9'}
                                                        onMouseOut={e => e.target.style.backgroundColor = 'transparent'}
                                                    >
                                                        {t.ad}
                                                    </li>
                                                ))}
                                            </ul>
                                            <div style={{ textAlign: 'right', marginTop: '20px' }}>
                                                <button type="button" className="action-button cancel-button" onClick={() => setShowTeacherDropdown(false)}>Bağla</button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '10px' }}>
                                <button type="button" className="action-button cancel-button" onClick={() => setShowNewConsultationModal(false)}>Ləğv Et</button>
                                <button type="submit" className="action-button" style={{ margin: 0 }}>Qeydiyyata Al</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {loading ? <p>Yüklənir...</p> : (
                <>
                    <div className="admin-tabs" style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e2e8f0', paddingBottom: '10px', overflowX: 'auto' }}>
                        <button 
                            onClick={() => {
                                setConsultationTab('today');
                                if (currentUser?.level === 3) {
                                    const me = teachers.find(t => t.fin === currentUser?.fin);
                                    if (me) setConsultationTeacherFilter(me.ad);
                                }
                            }}
                            style={{ 
                                padding: '8px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                                backgroundColor: consultationTab === 'today' ? '#e74c3c' : '#e2e8f0',
                                color: consultationTab === 'today' ? '#fff' : '#475569', fontWeight: 'bold'
                            }}
                        >
                            Bugünkü Konsultasiyalar ({todaysConsultations.length})
                        </button>
                        <button 
                            onClick={() => {
                                setConsultationTab('all');
                                if (currentUser?.level === 3) {
                                    setConsultationTeacherFilter('Hamısı');
                                }
                            }}
                            style={{ 
                                padding: '8px 16px', borderRadius: '20px', border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                                backgroundColor: consultationTab === 'all' ? '#2c3e50' : '#e2e8f0',
                                color: consultationTab === 'all' ? '#fff' : '#475569', fontWeight: 'bold'
                            }}
                        >
                            Bütün Pasiyentlər
                        </button>
                    </div>

                    {consultationTab === 'today' && (
                        <ul className="appointment-list">
                            {todaysConsultations.length > 0 ? (
                                todaysConsultations.filter(p => p.ad.toLowerCase().includes(searchTerm.toLowerCase())).map((patient, index) => (
                                    <li key={`today-${index}`} className="appointment-item" onClick={() => handleUnregisteredClick(patient)}>
                                        <div className="appointment-details">
                                            <strong>{patient.ad}</strong>
                                            <p>
                                                <span>Sərbəst Qeydiyyat</span> | 
                                                <span> {patient.telefon || 'Nömrə yoxdur'}</span> | 
                                                <span style={{ color: '#e74c3c', fontWeight: 'bold' }}> Saat: {patient.konsultasiya_saati || 'Təyin edilməyib'}</span>
                                                {patient.assigned_teacher && <span style={{ color: '#3498db', fontWeight: 'bold' }}> | Mütəxəssis: {patient.assigned_teacher}</span>}
                                            </p>
                                        </div>
                                    </li>
                                ))
                            ) : <p>Bu gün üçün planlaşdırılan konsultasiya yoxdur.</p>}
                        </ul>
                    )}

                    {consultationTab === 'all' && (
                        <ul className="appointment-list">
                            {visibleUnregisteredPatients.length > 0 ? (
                                visibleUnregisteredPatients.filter(p => p.ad.toLowerCase().includes(searchTerm.toLowerCase())).map((patient, index) => (
                                    <li key={index} className="appointment-item" onClick={() => handleUnregisteredClick(patient)}>
                                        <div className="appointment-details">
                                            <strong>{patient.ad}</strong>
                                            <p>
                                                <span>Sərbəst Qeydiyyat</span> | 
                                                <span> {patient.telefon || 'Nömrə yoxdur'}</span> | 
                                                <span> Planlaşdırılan: {patient.konsultasiya_tarixi ? new Date(patient.konsultasiya_tarixi).toLocaleDateString('az-AZ') + ' ' + (patient.konsultasiya_saati || '') : 'Yoxdur'}</span>
                                                {patient.assigned_teacher && <span style={{ color: '#3498db', fontWeight: 'bold' }}> | Mütəxəssis: {patient.assigned_teacher}</span>}
                                            </p>
                                        </div>
                                    </li>
                                ))
                            ) : (
                                <p>Sərbəst konsultasiya tapılmadı.</p>
                            )}
                        </ul>
                    )}
                </>
            )}
          </>
        );
      default:
        return <h2>Əsas Səhifə</h2>;
    }
  };

  return (
    <div className={`dashboard-layout ${activeView === 'menu' ? 'menu-view' : ''}`}>
      {activeView !== 'menu' && (
        <>
          <button className="mobile-menu-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>☰</button>
          <aside className={`dashboard-menu ${isSidebarOpen ? 'open' : ''}`}>
            <div className="menu-header">
              <h3>QNPM Panel</h3>
            </div>
            <nav className="menu-nav" onClick={() => setIsSidebarOpen(false)}>
          <a href="#home" onClick={() => handleViewChange('menu')} className={activeView === 'menu' ? 'active' : ''}>Ana Səhifə</a>
          <a href="#qebullar" onClick={() => handleViewChange('qebullar')} className={activeView === 'qebullar' ? 'active' : ''}>Bugünkü Qəbullar</a>
          <a href="#cedveller" onClick={() => handleViewChange('cedveller')} className={activeView === 'cedveller' ? 'active' : ''}>Cədvəllər</a>
          <a href="#xesteler" onClick={() => handleViewChange('xesteler')} className={activeView === 'xesteler' ? 'active' : ''}>Xəstələr</a>
          <a href="#s_konsultasiyalar" onClick={() => handleViewChange('s_konsultasiyalar')} className={activeView === 's_konsultasiyalar' ? 'active' : ''}>Sərbəst Konsultasiyalar</a>
          <a href="#maliyya" onClick={() => handleViewChange('maliyya')} className={activeView === 'maliyya' ? 'active' : ''}>Maliyyə</a>
          <a href="#ayarlar" onClick={() => handleViewChange('ayarlar')} className={activeView === 'ayarlar' ? 'active' : ''}>Ayarlar</a>
          {currentUser?.level === 3 && (
              <a href="#admin_panel" onClick={() => handleViewChange('admin_panel')} className={activeView === 'admin_panel' ? 'active' : ''}>Admin Panel</a>
          )}
            </nav>
            <div className="menu-footer">
              <button onClick={onLogout} className="logout-button">Çıxış</button>
            </div>
          </aside>
        </>
      )}
      <main className="dashboard-panel">
        <header className="panel-header">
          <div className="header-left">
             {activeView !== 'menu' && <button className="back-to-menu" onClick={() => handleViewChange('menu')}>⬅ Menyu</button>}
             <h1>İdarəetmə Paneli</h1>
          </div>
          <div className="user-badge" style={{ fontWeight: 'bold' }}>
            {currentUser?.ad ? `Salam, ${formatText(currentUser.ad)}` : 'Mütəxəssis'}
          </div>
        </header>
           {(activeView === 'xesteler' || activeView === 's_konsultasiyalar') && (
          <div className="panel-filters">
            <div className="filter-section" style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                {activeView === 'xesteler' && (
                  <div>
                    <label htmlFor="filial-select" style={{ marginRight: '10px', fontWeight: 'bold' }}>Filial Seçin:</label>
                    <select 
                      id="filial-select"
                      value={selectedFilial} 
                      onChange={(e) => setSelectedFilial(e.target.value)}
                      style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc' }}
                    >
                      {filialList.map((f, index) => (
                        <option key={index} value={f}>{f}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div>
                  <label htmlFor="name-search" style={{ marginRight: '10px', fontWeight: 'bold' }}>Xəstə Adı:</label>
                  <input 
                    type="text" 
                    id="name-search" 
                    placeholder="Ad ilə axtarış..." 
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{ padding: '8px', borderRadius: '5px', border: '1px solid #ccc', minWidth: '250px' }}
                  />
                </div>
              </div>
          </div>
        )}
        <div className="panel-content">
          {renderView()}
        </div>
        {selectedPatient && selectedAppointment && <PatientDetail patient={{...selectedPatient, ...selectedAppointment}} currentUser={currentUser} onClose={handleCloseDetail} initialTestToOpen={initialTestToOpen} initialTestToView={initialTestToView} />}
      </main>

      {/* --- Mobil və Ekran Uyğunluğu (Responsive) üçün CSS --- */}
      <style>{`
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }

        /* Çap (Print) Rejimi Üçün CSS */
        @media print {
          .dashboard-menu, .panel-header, .mobile-menu-toggle, .schedule-header-row, .back-to-menu, .panel-filters {
            display: none !important;
          }
          .dashboard-layout, .dashboard-panel, .panel-content {
            display: block !important;
            width: 100% !important;
            margin: 0 !important;
            padding: 0 !important;
            height: auto !important;
            overflow: visible !important;
          }
          [data-html2canvas-ignore="true"], .action-button {
            display: none !important;
          }
          .finance-content {
            box-shadow: none !important;
            border: none !important;
            padding: 0 !important;
          }
        }

        .table-responsive {
          width: 100%;
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }
        .schedule-table {
          width: 100%;
          border-collapse: collapse;
        }
        @media screen and (max-width: 768px) {
          .schedule-table th, .schedule-table td {
            padding: 10px 8px !important;
            font-size: 0.85rem;
            white-space: nowrap; /* Mətnin alt-alta düşməməsini və cədvəlin scroll olmasını təmin edir */
          }
          .finance-summary-card {
            padding: 15px !important;
          }
          .finance-summary-card h3 {
            font-size: 1.15rem !important;
          }
          .action-button {
            padding: 8px 12px !important;
            font-size: 0.85rem !important;
          }
          .finance-lessons, .finance-expenses {
            padding: 15px 10px !important;
          }
          .schedule-filter-controls button, .schedule-status-filters button {
            font-size: 0.85rem !important;
            padding: 6px 12px !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Dashboard;